import React from 'react';
import { Check } from 'lucide-react';
import { PasswordRules } from '../../utils/passwordRules';

/** The live checklist under a new-password form; ticks turn success ink. */
const RULES: { key: keyof PasswordRules; label: string }[] = [
  { key: 'longEnough', label: '8 or more characters' },
  { key: 'notEmail', label: 'Not your email address' },
  { key: 'matches', label: 'Both passwords match' },
];

export const PasswordRuleList: React.FC<{ rules: PasswordRules }> = ({ rules }) => (
  <ul aria-label="Password rules" className="mb-[16px] flex flex-col gap-s1">
    {RULES.map(({ key, label }) => {
      const met = rules[key];
      return (
        <li
          key={key}
          className={`flex items-center gap-s2 text-body-sm transition-colors ${met ? 'text-success-ink' : 'text-ink-muted'}`}
        >
          <Check aria-hidden className="h-[13px] w-[13px] shrink-0" strokeWidth={2.5} />
          <span>{label}</span>
          <span className="sr-only">{met ? '(done)' : '(not yet)'}</span>
        </li>
      );
    })}
  </ul>
);

export default PasswordRuleList;
